var v1="<span ng-if=\"!editMode\">{{ score.ob != 0 ? score.ob : ''}}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" empty-value=\"true\" ng-model=\"score.ob\" disable=\"!isShotEntered(score)\" options=\"defaultData.ob_waterOptions\" class=\"input white\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/ob.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/ob.jade
// module id = 402
// module chunks = 0